import * as React from "react";
const SvgGripSelected = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 52, viewBox: "0 0 40 52", id: "svg8", ...props }, /* @__PURE__ */ React.createElement("defs", { id: "defs2" }), /* @__PURE__ */ React.createElement("g", { id: "layer1" }, /* @__PURE__ */ React.createElement("rect", { style: {
  fill: "#f50057",
  fillOpacity: 0.99999994,
  fillRule: "evenodd",
  strokeWidth: 3.22727,
  imageRendering: "auto"
}, id: "rect18", width: 6, height: 52, x: 0, y: 0 }), /* @__PURE__ */ React.createElement("rect", { y: 13, x: 19, height: 5.9999995, width: 5.9999995, id: "rect845", style: {
  fill: "#000000",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  strokeWidth: 0.809628,
  imageRendering: "auto"
} }), /* @__PURE__ */ React.createElement("rect", { style: {
  fill: "#000000",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  strokeWidth: 0.809631,
  imageRendering: "auto"
}, id: "rect845-1", width: 5.9999995, height: 5.9999995, x: 29, y: 13 }), /* @__PURE__ */ React.createElement("rect", { style: {
  fill: "#000000",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  strokeWidth: 0.809628,
  imageRendering: "auto"
}, id: "rect845-4", width: 6, height: 5.9999995, x: 18.999998, y: 23 }), /* @__PURE__ */ React.createElement("rect", { y: 23, x: 29, height: 5.9999995, width: 6, id: "rect845-1-5", style: {
  fill: "#000000",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  strokeWidth: 0.809631,
  imageRendering: "auto"
} }), /* @__PURE__ */ React.createElement("rect", { y: 33, x: 18.999998, height: 5.9999995, width: 6, id: "rect902", style: {
  fill: "#000000",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  strokeWidth: 0.809628,
  imageRendering: "auto"
} }), /* @__PURE__ */ React.createElement("rect", { style: {
  fill: "#000000",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  strokeWidth: 0.809631,
  imageRendering: "auto"
}, id: "rect904", width: 6, height: 5.9999995, x: 29, y: 33 })));
export default SvgGripSelected;
